export enum Type {
    Default = 'default',
    Filter = 'filter',
    Download = 'download'
}

export enum DropdownDirection {
    Down = 'down',
    Up = 'up'
}
